import React from "react";

import {
    StyleSheet,
    Text,
    ActivityIndicator,
    View,
    TouchableOpacityProps,
    TouchableOpacity,
    ViewStyle,
    TextStyle
} from 'react-native';

import AppTheme, { Theme } from "../utils/Theme";
import SVGView from "../utils/SvgView";

interface ButtonProps extends TouchableOpacityProps {
    inversed?: boolean,
    isLoading?: boolean,
    link?: boolean,
    title?: string,
    textStyle?: TextStyle,
    icon?: any
}

const Button = (props: ButtonProps) => {

    const {
        isLoading,
        link = false,
        disabled = false,
        title,
        textStyle,
        icon,
        style,
        ...restProps
    } = props;

    const appTheme: AppTheme = new AppTheme();

    const buttonStyle: ViewStyle = link === false ? {
        paddingVertical: appTheme.pixelPerfect(4),
        borderRadius: appTheme.pixelPerfect(40),
        justifyContent: "center",
        alignItems: "center"
    } : {
        borderRadius: appTheme.pixelPerfect(20),
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'transparent'
    };
    let backgroundColor = link === true ? "transparent" : ((style !== undefined) && (style.backgroundColor !== undefined)) ? style.backgroundColor : appTheme.buttonBackgroundColor;
    let pressedBackgroundColor = ((style !== undefined) && (style.pressedBackgroundColor !== undefined)) ? style.pressedBackgroundColor : backgroundColor + "33";
    let buttonTitle = title !== undefined ? title : 'OK';
    let titleColor = ((textStyle !== undefined) && (textStyle.color !== undefined)) ? textStyle.color : link === true ? appTheme.textColor : appTheme.white;
    let titleFontSize = ((textStyle !== undefined) && (textStyle.fontSize !== undefined)) ? textStyle.fontSize : appTheme.pixelPerfectForFont(10);
    let textDecorationLine = link === true ? "underline" : "none";
    let contextStyle = {
        backgroundColor,
        color: titleColor
    };

    const iconView = icon !== undefined ? <View style={{ width: appTheme.pixelPerfect(40), alignItems: "center" }}><SVGView Component={icon} color={titleColor} size={appTheme.pixelPerfect(20)} /></View> : null;
    const buttonContent = ((isLoading !== undefined) && (isLoading === true)) ?
        <ActivityIndicator color={titleColor} /> :
        <View style={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
            {iconView}
            <Text style={[{ flex: 1, color: titleColor, textDecorationLine, fontFamily: appTheme.primarySemiBoldFont, fontSize: titleFontSize, textAlign: "center" }, textStyle]}>{buttonTitle}</Text>
        </View>;


    return (
        <TouchableOpacity
            disabled={disabled}
            style={[
                buttonStyle,
                style,
                contextStyle]}
            {...restProps}>
            {buttonContent}
        </TouchableOpacity>
    )

}

export default Button;

const styles = StyleSheet.create({
    shadowed: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.30,
        shadowRadius: 4.65,

        elevation: 8,
    },
    pressed_shadowed: {
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,

        elevation: 4,
    }
});